/// <amd-module name="WorkItemsHub/Utils/WorkItemsHubDataUtils" />
import * as Utils_String from "VSS/Core/Util/String";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { WorkItemsHubProcessData } from "Generated/Contracts";
import * as Resources from "WorkItemsHub/Resources";

export function getFieldFriendlyName(fieldReferenceName: string, hubProcessData: WorkItemsHubProcessData): string {
    if (hubProcessData.fieldReferenceNames) {

        // Hack to show 'Comments' instead of 'Comment Count'
        if (Utils_String.equals(fieldReferenceName, CoreFieldRefNames.CommentCount, true)) {
            return Resources.WorkItemsHubComments;
        }

        const index = hubProcessData.fieldReferenceNames.indexOf(fieldReferenceName);
        if (index >= 0) {
            return hubProcessData.fieldFriendlyNames[index];
        }
    }

    return fieldReferenceName;
}

export function getNormalizedValue(value: string): string {
    value = value || "";
    return value.trim().toLowerCase();
}
